import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import {reduxForm, getFormSyncErrors, getFormSubmitErrors, touch, setSubmitFailed, isDirty, getFormValues} from 'redux-form'
import { I18n } from 'react-i18next'
import _ from 'lodash'
import './Form.css'
import {setUiMode, setObjectMode, emptyEditObject, setLastEditDate, setEditIndex, setEditedRowId} from '../../actions'
import { saveFormObject, createObject } from '../../actions/api'
import { executeLoadSubscriptions, executeAfterSaveSubscriptions } from '../../actions/module'
import { Form, FormField, FormButtons } from '../../../../components/Form'
import { FormSection } from '../../../../components/Form/FormSection'
import ModuleFormField from './Field'
import BsButton from '../../../../components/BsButton'
import { toastr } from 'react-redux-toastr'
import SpinningDots from '../../../../components/Loader/SpinningDots'
import {
    getEditFields,
    getEditIsFetching,
    getEditObjectId,
    getEditObjectData,
    getModule,
    getLanguage,
    getEditButtons,
    getObjectMode,
    getMode,
    getFormUi, getGroupModel, getUser, getSectionStates
} from '../../selectors'
import { Prompt } from 'react-router-dom'
import FormWrapper from './FormWrapper'
export const OBJECT_FORM = 'editObject'

class ModuleForm extends PureComponent {
    componentDidMount(){
        this.props.executeLoadSubscriptions()
    }
    renderButtons() {
        const {
            fields,
            // from redux form
            //dirty,
            invalid,
            //pristine,
            //submitting,
            handleSubmit,

            // dispatch
            touch,
            setFormSubmitFailed,
            setEditedRowId,
            onCancel,
            onSubmitWithContext,

            // connected
            objectId,
            module,
            editButtons,
            formSyncErrors,
            formSubmitErrors,
            isFormDirty,
            buttonContainerStyle,
            formLoading,
            editObjectValues
        } = this.props

        return (
            <I18n ns={[module.model, 'platform']}>
                {t =>
                    <FormButtons style={module.buttonContainerStyle}>
                        {editButtons.map((button, i) => {
                            switch (button.type) {
                                case "save":
                                    return (
                                        <BsButton
                                            key={i}
                                            type='submit'
                                            bsStyle={button.bsStyle}
                                            disabled={!isFormDirty || formLoading}
                                            onClick={() => {
                                                const key = _.keys(formSyncErrors)[0]
                                                const field = _.find(fields, {'path': key} )

                                                if(invalid && formSyncErrors) {

                                                    const fieldPaths = fields.map(field => field.path)
                                                    setFormSubmitFailed(fieldPaths)

                                                    return toastr.error(
                                                        t('validationError'),
                                                        t(field.tKey) + ' : ' + t(formSyncErrors[`${key}`]._error || formSyncErrors[`${key}`])
                                                    )
                                                } else if(invalid && formSubmitErrors) {
                                                    return toastr.error(
                                                        t('validationError'),
                                                        t(formSubmitErrors['serverError'])
                                                    )
                                                }

                                                setEditedRowId(objectId)
                                                handleSubmit(object => {
                                                    // confirmIfEmpty: ask for a confirmation when the given field is left empty
                                                    const confirm = !!button.confirmIfEmpty && _.isEmpty(_.get(object, button.confirmIfEmpty))
                                                    return onSubmitWithContext({
                                                        object,
                                                        context: {
                                                            action: 'save',
                                                            tKey: t(button.tKey),
                                                            getUserConfirmation: confirm,
                                                            confirmationMessage: confirm ? button.confirmationMessage : undefined
                                                        }
                                                    })
                                                })()
                                            }}
                                        >
                                            {t(button.tKey)}
                                        </BsButton>
                                    )
                                case "action":
                                    const disabled = button.pristine
                                        ? !isFormDirty || formLoading
                                        : formLoading
                                    return (
                                        <BsButton
                                            key={i}
                                            onClick={() => {
                                                const key = _.keys(formSyncErrors)[0]
                                                const field = _.find(fields, {'path': key} )

                                                if(button.bypassFormValidation) {
                                                    setEditedRowId(objectId)
                                                    return onSubmitWithContext({
                                                        object: editObjectValues,
                                                        context: {
                                                            action: button.action,
                                                            tKey: t(button.tKey),
                                                            getUserConfirmation: button.getUserConfirmation,
                                                            confirmationMessage: button.confirmationMessage
                                                        }
                                                    })
                                                }

                                                if (invalid && formSyncErrors) {

                                                    const fieldPaths = fields.map(field => field.path)
                                                    setFormSubmitFailed(fieldPaths)

                                                    return toastr.error(
                                                        t('validationError'),
                                                        t(field && field.tKey) + ' : ' + t(formSyncErrors[`${key}`]._error || formSyncErrors[`${key}`])

                                                    )
                                                } else if(invalid && formSubmitErrors) {
                                                    return toastr.error(
                                                        t('validationError'),
                                                        t(formSubmitErrors['serverError'])
                                                    )
                                                }
                                                handleSubmit(object => {
                                                    return onSubmitWithContext({
                                                        object,
                                                        context: {
                                                            action: button.action,
                                                            tKey: t(button.tKey),
                                                            getUserConfirmation: button.getUserConfirmation,
                                                            confirmationMessage: button.confirmationMessage
                                                        }
                                                    })
                                                })()
                                                setEditedRowId(objectId)
                                            }}
                                            bsStyle={button.bsStyle}
                                            disabled={disabled}
                                        >
                                            {t(button.tKey)}
                                        </BsButton>
                                    )
                                case "return":
                                default:
                                    return (
                                        <BsButton
                                            key={i}
                                            bsStyle={button.bsStyle}
                                            onClick={() => {
                                                onCancel(isFormDirty)
                                            }}
                                        >
                                            {t(button.tKey)}
                                        </BsButton>
                                    )
                            }
                        })}
                    </FormButtons>

                }
            </I18n>
        )
    }

    renderForm() {
        const {
            handleSubmit, fields, user, module, groupModel, objectMode, isFormDirty, initialValues, editObjectValues, language, formLoading, selectedColor, sectionStates
        } = this.props


        const filteredFields = fields
            .filter(field => !field.hidden)
            .filter(field => objectMode === "newObject" || !field.creationOnly)

        const declaredSectionIds = new Set((module.formSections || []).map(s => s.id))
        const hasSections = declaredSectionIds.size > 0

        const requiredField = fields.some(field => field.required)
        return (
            <I18n key={module.model} ns={[module.model, 'platform']}>
                {t => {
                    return (
                        <FormWrapper isFormDirty={isFormDirty} message={t('quittingFormConfirmation')}>
                            <Form onSubmit={handleSubmit} hideScroll={module.hideScroll}>
                                <Prompt
                                    when={isFormDirty}
                                    message={t('quittingFormConfirmation')}
                                />
                                { !hasSections && filteredFields
                                    .map(field => (
                                        <FormField key={field.path} type={field.type} required={field.required} hideLabel={field.hideLabel} width={field.width} label={field.tKey} fullWidth={field.fullWidth} widthClassName={field.widthClassName} t={t} >
                                            <ModuleFormField field={field} t={t} objectMode={objectMode} initialValues={initialValues} editObjectValues={editObjectValues} language={language} user={user} module={module} groupModel={groupModel} selectedColor={selectedColor}/>
                                        </FormField>
                                    ))
                                }

                                {hasSections && (() => {
                                    const blocks = filteredFields.reduce((acc, field) => {
                                        if (!field.section || !declaredSectionIds.has(field.section)) {
                                            acc.push({ type: 'field', field })
                                            return acc
                                        }

                                        const existingSection = acc.find(b => b.type === 'section' && b.sectionId === field.section)

                                        if (existingSection) {
                                            existingSection.fields.push(field)
                                        } else {
                                            acc.push({
                                                type: 'section',
                                                sectionId: field.section,
                                                fields: [field],
                                            })
                                        }

                                        return acc
                                    }, [])

                                    return blocks.map(block => {
                                        if (block.type === 'field') {
                                            const field = block.field
                                            return (
                                                <FormField key={field.path} type={field.type} required={field.required} hideLabel={field.hideLabel} width={field.width} label={field.tKey} fullWidth={field.fullWidth} widthClassName={field.widthClassName} t={t}>
                                                    <ModuleFormField field={field} t={t} objectMode={objectMode} initialValues={initialValues} editObjectValues={editObjectValues} language={language} user={user} module={module} groupModel={groupModel} selectedColor={selectedColor}/>
                                                </FormField>
                                            )

                                        }

                                        const sectionDetails = module.formSections?.find(
                                            section => section.id === block.sectionId
                                        )

                                        return (
                                            <FormSection
                                                key={`section-${block.sectionId}`}
                                                title={sectionStates[block.sectionId]?.tKey || t(sectionDetails?.tKey || block.sectionId)}
                                                collapsible
                                                defaultCollapsed={!!sectionDetails?.defaultCollapsed}
                                                color={sectionDetails?.color}
                                                forcedCollapsed={sectionStates[block.sectionId]?.collapsed}
                                            >
                                                {block.fields.map(field =>
                                                    <FormField key={field.path} type={field.type} required={field.required} hideLabel={field.hideLabel} width={field.width} label={field.tKey} fullWidth={field.fullWidth} widthClassName={field.widthClassName} t={t} >
                                                        <ModuleFormField field={field} t={t} objectMode={objectMode} initialValues={initialValues} editObjectValues={editObjectValues} language={language} user={user} module={module} groupModel={groupModel} selectedColor={selectedColor}/>
                                                    </FormField>
                                                )}
                                            </FormSection>
                                        )
                                    })
                                })()}

                                {this.renderButtons()}
                                {requiredField &&  <div className='col-sm-12' style={{marginLeft: '5px', fontSize: '11px'}}>(*) {t('requiredFields')}</div>}
                            </Form>
                            {
                                formLoading && <div className="Form-loading-Modal">
                                    <SpinningDots/>
                                </div>
                            }
                        </FormWrapper>
                    )
                }}
            </I18n>
        )
    }

    render() {
        const {objectMode, isFetching} = this.props
        const isNewObject = objectMode === 'newObject'
        return isFetching && !isNewObject ? <SpinningDots /> : this.renderForm()
    }
}

const ReduxForm = reduxForm({
    // a unique name for the form (required by the library)
    form: OBJECT_FORM,
    // loads values when initialValues prop changes
    enableReinitialize: true,
    //keepDirtyOnReinitialize: true
})(ModuleForm)

const mapStateToProps = state => ({
    formSyncErrors: getFormSyncErrors(OBJECT_FORM)(state),
    formSubmitErrors: getFormSubmitErrors(OBJECT_FORM)(state),
    fields: getEditFields(state),
    isFetching: getEditIsFetching(state),
    objectId: getEditObjectId(state),
    initialValues: getEditObjectData(state),
    editButtons: getEditButtons(state),
    user: getUser(state),
    module: getModule(state),
    groupModel: getGroupModel(state),
    formLoading: getFormUi(state).loading,
    sectionStates: getSectionStates(state),
    language: getLanguage(state),
    objectMode: getObjectMode(state),
    isFormDirty: isDirty(OBJECT_FORM)(state),
    editObjectValues: getFormValues(OBJECT_FORM)(state),
    mode: getMode(state)
})

const mapDispatchToProps = (dispatch, { t }) => ({
    touch: field => dispatch(touch(OBJECT_FORM, field)),
    setFormSubmitFailed: fields => dispatch(setSubmitFailed(OBJECT_FORM, ...fields)),
    setObjectMode: objectMode => dispatch(setObjectMode(objectMode)),
    setEditedRowId: id => {
        dispatch(setEditedRowId(id))
        setTimeout(() => {
            dispatch(setEditedRowId(null))
        }, 5000)
    },
    onCancel: (isFormDirty) => {
        if(isFormDirty) {
            toastr.confirm(t('quittingFormConfirmation'), {
                onOk: () => {
                    dispatch(setUiMode('list'))
                    dispatch(emptyEditObject())
                    dispatch(setObjectMode(''))
                }
            })
        } else {
            dispatch(setUiMode('list'))
            dispatch(emptyEditObject())
            dispatch(setObjectMode(''))
        }
    },
    onSubmitWithContext: ({ object, context }) => {
        const newObject = !object.id
        const action = newObject ? createObject : saveFormObject

        const dispatchAction = () => {
            return dispatch(action(object, context))
                .then(({ error }) => {
                    if (!error) dispatch(executeAfterSaveSubscriptions())
                })
                .catch((error) => console.log(error))
        }
        return context.getUserConfirmation
            ? toastr.confirm( t(context.confirmationMessage || 'formActionConfirmation', {action: context.tKey}), {
                onOk: () => dispatchAction()
            })
            : dispatchAction()
    },
    executeLoadSubscriptions: () => dispatch(executeLoadSubscriptions())
})

export default connect(mapStateToProps, mapDispatchToProps)(ReduxForm)
